import React from "react";
import { useTranslate } from "@refinedev/core";
import {
  SettingOutlined,
  FileProtectOutlined,
  ApiOutlined,
  BarChartOutlined,
  ExperimentOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import { TabHub } from "../../../components/TabHub";
import { TenantGeneralForm } from "../../../components/tenant/TenantGeneralForm";
import { InvoiceSettings } from "../../invoice-settings";
import { UsagePage } from "../../usage";
import { DemoDataTab } from "./components/DemoDataTab";
import { OpeningHoursTab } from "./components/OpeningHoursTab";

/**
 * Organisation hub — settings that apply to the whole tenant.
 *
 * Replaces the old `/settings/general`, `/invoice-settings` and `/usage` pages,
 * which were three unrelated top-level entries for one scope of effect.
 */
export const OrganizationConfigurationPage: React.FC = () => {
  const _t = useTranslate();

  return (
    <div className="max-w-7xl mx-auto">
      <TabHub
        title={_t("configuration.organization", "Organization")}
        subtitle={_t("configuration.organizationSubtitle", "")}
        items={[
          {
            key: "general",
            label: _t("configuration.org.tabs.general", "General"),
            icon: <SettingOutlined />,
            children: <TenantGeneralForm scope="self" />,
          },
          {
            key: "invoicing",
            label: _t("configuration.org.tabs.invoicing", "Invoicing"),
            icon: <FileProtectOutlined />,
            children: <InvoiceSettings section="invoicing" hideHeader />,
          },
          {
            key: "integrations",
            label: _t("configuration.org.tabs.integrations", "Integrations"),
            icon: <ApiOutlined />,
            children: <InvoiceSettings section="integrations" hideHeader />,
          },
          {
            key: "openingHours",
            label: _t("configuration.org.tabs.openingHours", "Opening hours"),
            icon: <ClockCircleOutlined />,
            children: <OpeningHoursTab />,
          },
          {
            key: "subscription",
            label: _t("configuration.org.tabs.subscription", "My usage"),
            icon: <BarChartOutlined />,
            children: <UsagePage hideHeader />,
          },
          {
            key: "demoData",
            label: _t("configuration.org.tabs.demoData", "Demo data"),
            icon: <ExperimentOutlined />,
            children: <DemoDataTab />,
          },
        ]}
      />
    </div>
  );
};
